import { useGyymClient } from '@gyym/sdk-react'
import { usePathname, useRouter } from 'next/navigation'
import React from 'react'

import { useAuthUser } from './useAuthUser'

export const useLogout = () => {
  const client = useGyymClient()
  const [isLoggingOut, setIsLoggingOut] = React.useState(false)
  const router = useRouter()
  const pathname = usePathname()

  const { revalidate } = useAuthUser()

  const logoutFn = React.useCallback(async () => {
    // Navigate to TOP before logout
    if (pathname !== '/') {
      router.push('/')
    }

    setIsLoggingOut(true)
    await client.auth.user.logout()
    await revalidate()
    setIsLoggingOut(false)
  }, [client, revalidate, router, pathname])

  return { logout: logoutFn, isLoggingOut }
}
